"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LootBoxStatus = void 0;
var LootBoxStatus;
(function (LootBoxStatus) {
    LootBoxStatus["ACTIVE"] = "ACTIVE";
    LootBoxStatus["INACTIVE"] = "INACTIVE";
})(LootBoxStatus || (exports.LootBoxStatus = LootBoxStatus = {}));
//# sourceMappingURL=box.js.map